import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CleanupComponent } from '@core/helpers/Cleanup';
import { HttpMonitoringService } from '@core/services/http-monitoring.service';
import { NavigatonService } from '@core/services/navigation.service';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { TitleService } from '@core/services/title.services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends CleanupComponent implements OnInit, OnDestroy {

  hasRequests = false;
  env = environment;
  isDashboard = false;

  constructor(private _httpMonitoringService: HttpMonitoringService,
    public router: Router,
    private _navigatonService: NavigatonService,
    private titleService: TitleService,
    private change: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.titleService.setTitle();
    this.sub.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const root = this.router.url.toString().split('/')[1];
        this._navigatonService.setSubNavByUrl(`/${root}`);
        this.isDashboard = this.router.url.indexOf('dashboard') !== -1 ? true : false;
        window.scrollTo(0,0);
        this.change.detectChanges();
      }
    }));

    this.sub.add(this._httpMonitoringService.activeConnections$.pipe(map(theNumber => {
      this.hasRequests = (theNumber > 0) ? true : false;
      const allForms = document.querySelectorAll('form');
      if (this.hasRequests) {
        allForms.forEach(form => {
          form.style.pointerEvents = 'none';
        });
      } else {
        allForms.forEach(form => {
          form.style.pointerEvents = 'initial';
        });
      }

      this.change.detectChanges();
      return this.hasRequests;
    })).subscribe());
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
